// components/Registration/HoroscopeStep.js
import React, { useRef } from "react";
import { Button, TextField } from "@mui/material";
import Autocomplete from "@material-ui/lab/Autocomplete";
import exampleChart from "../../../assests/images/chat_new_en.png";
import raasiImage from "../../../assests/images/raaasi_en.png";
import amsamImage from "../../../assests/images/amsam_en.png";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function HoroscopeStep({
    formData,
    setFormData,
    validateError,
    stars,
    zodiacs,
    dhosams,
    directions
}) {
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleTimeChange = (date) => {
        if (date) {
            const formattedTime = `${date.getHours().toString().padStart(2, "0")}:${date
                .getMinutes()
                .toString()
                .padStart(2, "0")}`;

            setFormData((prev) => ({
                ...prev,
                time_of_birth: formattedTime,
            }));
        } else {
            setFormData((prev) => ({ ...prev, time_of_birth: "" }));
        }
    }

    // Render 12 inputs positioned around the border
    const renderOuterBoxes = (prefix) => {
        const positions = [
            "1 / 1", "1 / 2", "1 / 3", "1 / 4", // top row (4)
            "2 / 1", "3 / 1",                   // left column (2)
            "2 / 4", "3 / 4",                   // right column (2)
            "4 / 1", "4 / 2", "4 / 3", "4 / 4"  // bottom row (4)
        ];

        return positions.map((gridArea, i) => (
            <TextField
                key={`${prefix}${i + 1}`}
                name={`${prefix}${i + 1}`}
                value={formData[`${prefix}${i + 1}`]}
                onChange={handleChange}
                inputProps={{ style: { textAlign: "center" } }}
                style={{
                    gridArea,
                    width: "45px",
                    height: "45px",
                    margin: "auto",
                    textAlign: "center"
                }}
            />
        ));
    };

    const pathams = [
        { title: "0", value: "0" },
        { title: "1", value: "1" },
        { title: "2", value: "2" },
        { title: "3", value: "3" },
        { title: "4", value: "4" },
    ];

    const fileInputRef = useRef(null);
    const handleRemovePhoto = () => {
        setFormData(prev => ({
            ...prev,
            jathgampicpath: null,
            jathgampic: null
        }));
        // Reset the file input
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    };

    const handleFile = (event) => {
        const file = event.target.files[0];
        if (file) {
            const maxSize = 2 * 1024 * 1024; // 2MB in bytes

            if (file.size > maxSize) {
                alert("File size must be less than 2MB!");
                event.target.value = ""; // clear the file input
                return;
            }
            const previewURL = URL.createObjectURL(file);
            setFormData((prev) => ({
                ...prev,
                jathgampic: previewURL,
                jathgampicpath: file,
            }));
        }
    };

    return (
        <div>

            {/* Time of Birth - Styled to match Date of Birth */}
            <div style={{ margin: "1em" }}>
                <DatePicker
                    selected={formData.time_of_birth
                        ? new Date(`1970-01-01T${formData.time_of_birth}:00`)
                        : null}
                    onChange={handleTimeChange}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={15}
                    timeCaption="Time"
                    dateFormat="h:mm aa"
                    placeholderText="Select time"
                    className="time-picker-input"
                    popperClassName="large-time-picker-popper"
                    customInput={
                        <TextField
                            fullWidth
                            required
                            label={<span>Time of Birth <span style={{ color: 'red' }}>*</span></span>}
                            error={!!validateError.time_of_birth}
                            helperText={validateError.time_of_birth}
                            variant="outlined"
                            sx={{
                                '& .MuiInputBase-input': {
                                    fontSize: '16px',
                                    padding: '16px',
                                    height: '17px',
                                    width: '71rem',
                                }
                            }}
                            FormHelperTextProps={{
                                style: { fontSize: "14px", color: "red" },
                            }}
                        />
                    }
                />
            </div>

            {/* Dropdowns */}
            <Autocomplete
                options={stars}
                getOptionLabel={(o) => (o?.title ? o.title : "")}
                getOptionSelected={(option, value) => option?.value === value?.value}
                value={formData.starname || null}
                onChange={(e, v) => setFormData((prev) => ({ ...prev, starname: v }))}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Star"
                        error={!!validateError.starname}
                        helperText={validateError.starname}
                        FormHelperTextProps={{
                            style: { fontSize: "14px", color: "red" },
                        }}
                        InputLabelProps={{
                            sx: {
                                ".MuiInputLabel-asterisk": {
                                    color: "red",
                                    fontSize: "1.2em",
                                }
                            }
                        }}
                        required
                    />
                )}
                style={{ margin: "1em" }}
            />
            <Autocomplete
                options={zodiacs}
                getOptionLabel={(o) => (o?.title ? o.title : "")}
                getOptionSelected={(option, value) => option?.value === value?.value}
                value={formData.zodiacname || null}
                onChange={(e, v) => setFormData((prev) => ({ ...prev, zodiacname: v }))}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Zodiac"
                        error={!!validateError.zodiacname}
                        helperText={validateError.zodiacname}
                        FormHelperTextProps={{
                            style: { fontSize: "14px", color: "red" },
                        }}
                        InputLabelProps={{
                            sx: {
                                ".MuiInputLabel-asterisk": {
                                    color: "red",
                                    fontSize: "1.2em",
                                }
                            }
                        }}
                        required
                    />
                )}
                style={{ margin: "1em" }}
            />
            <Autocomplete
                options={dhosams}
                getOptionLabel={(o) => (o?.title ? o.title : "")}
                getOptionSelected={(option, value) => option?.value === value?.value}
                value={formData.dhosam || null}
                onChange={(e, v) => setFormData((prev) => ({ ...prev, dhosam: v }))}
                name="dhosam"
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Dhosam"
                        error={!!validateError.dhosam}
                        helperText={validateError.dhosam}
                        FormHelperTextProps={{
                            style: { fontSize: "14px", color: "red" },
                        }}
                        InputLabelProps={{
                            sx: {
                                ".MuiInputLabel-asterisk": {
                                    color: "red",
                                    fontSize: "1.2em",
                                }
                            }
                        }}
                        required
                    />
                )}
                style={{ margin: "1em" }}
            />
            <Autocomplete
                options={directions}
                getOptionLabel={(o) => (o?.title ? o.title : "")}
                getOptionSelected={(option, value) => option?.value === value?.value}
                value={formData.directionname || null}
                onChange={(e, v) =>
                    setFormData((prev) => ({ ...prev, directionname: v }))
                }
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Direction"
                        error={!!validateError.directionname}
                        helperText={validateError.directionname}
                        FormHelperTextProps={{
                            style: { fontSize: "14px", color: "red" },
                        }}
                        InputLabelProps={{
                            sx: {
                                ".MuiInputLabel-asterisk": {
                                    color: "red",
                                    fontSize: "1.2em",
                                }
                            }
                        }}
                        required
                    />
                )}
                style={{ margin: "1em" }}
            />
            <Autocomplete
                options={pathams}
                getOptionLabel={(o) => (o?.title ? o.title : "")}
                getOptionSelected={(option, value) => option?.value === value?.value}
                value={formData.patham || null}
                onChange={(e, v) => setFormData((prev) => ({ ...prev, patham: v }))}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Patham"
                        error={!!validateError.patham}
                        helperText={validateError.patham}
                        FormHelperTextProps={{
                            style: { fontSize: "14px", color: "red" },
                        }}
                        InputLabelProps={{
                            sx: {
                                ".MuiInputLabel-asterisk": {
                                    color: "red",
                                    fontSize: "1.2em",
                                }
                            }
                        }}
                        required
                    />
                )}
                style={{ margin: "1em" }}
            />

            <div style={{ margin: "1em" }}>
                <TextField
                    fullWidth
                    label="Gothra"
                    name="gothra"
                    value={formData.gothra}
                    onChange={handleChange}
                    error={!!validateError.gothra}
                    helperText={validateError.gothra}
                    // style={{ margin: "1em" }}
                    FormHelperTextProps={{
                        style: { fontSize: "14px", color: "red" },
                    }}
                    sx={{
                        '& .MuiInputBase-input': {
                            fontSize: '16px',
                        }
                    }}
                    InputLabelProps={{
                        sx: {
                            ".MuiInputLabel-asterisk": {
                                color: "red",
                                fontSize: "1.2em",
                            }
                        }
                    }}
                    required
                />
            </div>

            {/* Horoscope Photo */}
            <div style={{ margin: "1em 0" }}>
                {formData.jathgampic && (
                    <div style={{ marginBottom: "8px" }}>
                        <img
                            src={formData.jathgampic}
                            alt="Profile"
                            style={{
                                maxWidth: "120px",
                                borderRadius: "8px",
                                marginBottom: "8px"
                            }}
                        />
                        <Button
                            variant="outlined"
                            color="error"
                            size="large"
                            onClick={handleRemovePhoto}
                            style={{ marginLeft: "8px" }}
                        >
                            Remove
                        </Button>
                    </div>
                )}
                <p style={{ fontSize: "14px" }}>Maximum file size : 2MB</p>

                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    component="label"
                    style={{
                        padding: "14px",
                        fontSize: "1rem",
                        fontWeight: "bold",
                        borderRadius: "6px",
                        background: "#B21919",
                        color: "#FFFFFF"
                    }}
                >
                    {formData.jathgampicpath ? "Change Horoscope Photo" : "Upload Horoscope Photo"}
                    <input
                        type="file"
                        accept="image/*"
                        hidden
                        onChange={handleFile}
                        ref={fileInputRef} // Add the ref here
                    />
                </Button>
            </div>

            {/* Top reference image (unchanged) */}
            <div style={{ textAlign: "center", marginBottom: "1em" }}>
                <img
                    src={exampleChart}
                    alt="Horoscope Guide"
                    style={{ width: "600px", maxWidth: "100%", marginBottom: "10px" }}
                />
            </div>

            {/* Two separate horoscope grids */}
            <div style={{ display: "flex", justifyContent: "center", gap: "60px", marginTop: "2em" }}>
                {/* Raasi Chart */}
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(4, 1fr)",
                        gridTemplateRows: "repeat(4, 1fr)",
                        gap: "4px",
                        width: "300px",
                        height: "300px",
                        border: "1px solid #aaa",
                        position: "relative",
                        background: "#fff"
                    }}
                >
                    {/* Inputs around border */}
                    {renderOuterBoxes("r")}
                    {/* Center image */}
                    <img
                        src={raasiImage}
                        alt="Raasi Chart"
                        style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: "110px",
                            height: "45px",
                            opacity: 0.9
                        }}
                    />
                </div>

                {/* Navamsa (Amsam) Chart */}
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(4, 1fr)",
                        gridTemplateRows: "repeat(4, 1fr)",
                        gap: "4px",
                        width: "300px",
                        height: "300px",
                        border: "1px solid #aaa",
                        position: "relative",
                        background: "#fff"
                    }}
                >
                    {/* Inputs around border */}
                    {renderOuterBoxes("a")}
                    {/* Center image */}
                    <img
                        src={amsamImage}
                        alt="Navamsa Chart"
                        style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: "110px",
                            height: "45px",
                            opacity: 0.9
                        }}
                    />
                </div>
            </div>
        </div>
    );
}